module.exports = __webpack_public_path__ + "img/video-img.aa88d322.jpg";